module.exports = "<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\">{{ titleText }}</h4></div><div class=\"modal-body alert-body\" ng-bind-html=\"errorText\"></div><div class=\"modal-footer\"><button ng-if=\"isErrConfig()\" class=\"btn\" ng-click=\"sendErr()\">{{:: 'Cообщить о проблеме' | gettext}}</button> <button class=\"btn\" ng-click=\"cancel()\">{{ textButton }}</button></div>"


//////////////////
// WEBPACK FOOTER
// ./src/core/alert-modal/alert-modal.component.html
// module id = 330
// module chunks = 0